import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from "../Common/Loading";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface Family {
  Login: string;
  Password: string;
  FName: string;
  LName: string;
  ActivityStatus: string;
  RegisteredDate: string;
  ExpiryDate: string;
  ChildName: string;
  Products: string;
  MDs: string;
  Brick: string;
  KGap: string;
  WPlan: string;
  D_LP: string;
  D_LP_E: string;
  MyInCentives: string;
  AccountType: string;
  CanAccessLessonPlan: string;
  CanEarnPoints: string;
  EMail: string;
  Dongles: string;
  SalesLogin: string;
  VoucherCode: string;
}

interface LoadFamiliesRequest {
  school_code: string;
  family_code: string;
  login: string;
  surname: string;
  email: string;
  startRecNo: number;
  rowsPerPage: number;
}

interface LoadFamiliesResponse {
  success: boolean;
  families: Family[];
  startRecNo: number;
  rowsPerPage: number;
  totalRecords: number;
  errorMesg?: string;
  error?: string;
}

const EL_ListFamilies: React.FC = () => {
  const navigate = useNavigate();

  // Refs for DOM elements
  const flyDivScrollableTableRef = useRef<HTMLDivElement>(null);
  const tblFilterRef = useRef<HTMLTableElement>(null);

  // State for search filters
  const [loginFilter, setLoginFilter] = useState('');
  const [surnameFilter, setSurnameFilter] = useState('');
  const [emailFilter, setEmailFilter] = useState('');

  // const [appliedLoginFilter, setAppliedLoginFilter] = useState('');
  // const [appliedSurnameFilter, setAppliedSurnameFilter] = useState('');
  // const [appliedEmailFilter, setAppliedEmailFilter] = useState('');

  // State for data
  const [families, setFamilies] = useState<Family[]>([]);
  const [selectedFamily, setSelectedFamily] = useState<Family | null>(null);
  const [startRecNo, setStartRecNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMesg, setErrorMesg] = useState('');
  const [selLogin, setSelLogin] = useState('');
  const [howAdded, setHowAdded] = useState('');

  document.body.style.backgroundColor = "azure"

  // Get session values
  const supportSchoolCode = sessionStorage.getItem('school_code') || '';
  const supportFamilyCode = sessionStorage.getItem('family_code') || '';

  // Load families data
  // const loadFamilies = useCallback(async (page: number = 1, rowsPerPage: number = 20) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch(`${API_BASE_URL}api/dealer/list_families/`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         school_code: supportSchoolCode,
  //         family_code: supportFamilyCode,
  //         login: appliedLoginFilter,
  //         surname: appliedSurnameFilter,
  //         email: appliedEmailFilter,
  //         startRecNo: page,
  //         rowsPerPage: rowsPerPage
  //       })
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     if (data.success) {
  //       setFamilies(data.families);
  //       setStartRecNo(data.startRecNo);
  //       setRowsPerPage(data.rowsPerPage);
  //       setTotalRecords(data.totalRecords);
  //       setErrorMesg(data.errorMesg || '');

  //       // Set selection if selLogin is provided
  //       if (selLogin && data.families.length > 0) {
  //         const selected = data.families.find((f: Family) => f.Login === selLogin);
  //         if (selected) {
  //           setSelectedFamily(selected);
  //         }
  //       }
  //     } else {
  //       setErrorMesg(data.error || 'Failed to load families');
  //     }
  //   } catch (error) {
  //     console.error('Error loading families:', error);
  //     setErrorMesg('Failed to load families. Please try again.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }, [
  //   supportSchoolCode,
  //   supportFamilyCode,
  //   appliedLoginFilter,
  //   appliedSurnameFilter,
  //   appliedEmailFilter
  // ]);


  const loadFamilies = useCallback(async (
    page: number = 1,
    rowsPerPage: number = 20,
    login: string = '',
    surname: string = '',
    email: string = ''
  ) => {
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}api/dealer/list_families/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          school_code: supportSchoolCode,
          family_code: supportFamilyCode,
          login: login,
          surname: surname,
          email: email,
          startRecNo: page,
          rowsPerPage: rowsPerPage
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setFamilies(data.families);
        setStartRecNo(data.startRecNo);
        setRowsPerPage(data.rowsPerPage);
        setTotalRecords(data.totalRecords);
        setErrorMesg(data.errorMesg || '');

        if (selLogin && data.families.length > 0) {
          const selected = data.families.find(
            (f: Family) => f.Login === selLogin
          );

          if (selected) {
            setSelectedFamily(selected);
          }
        }
      } else {
        setErrorMesg(data.error || 'Failed to load families');
      }
    } catch (error) {
      console.error('Error loading families:', error);
      setErrorMesg('Failed to load families. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [supportSchoolCode, supportFamilyCode, selLogin]);



  // Initialize
  // useEffect(() => {
  //   // Check if we have a selected login from URL
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const selLoginParam = urlParams.get('SelLogin') || '';
  //   if (selLoginParam) {
  //     setSelLogin(selLoginParam);
  //     // Load session values if available
  //     const tmpLogin = sessionStorage.getItem('TMP_LoginLike') || '';
  //     const tmpSurname = sessionStorage.getItem('TMP_LNameLike') || '';
  //     const tmpEmail = sessionStorage.getItem('TMP_EMailLike') || '';
  //     setLoginFilter(tmpLogin);
  //     setSurnameFilter(tmpSurname);
  //     setEmailFilter(tmpEmail);
  //   }

  //   // Load initial data
  //   loadFamilies(1, rowsPerPage);

  //   // Set window resize handler
  //   const handleResize = () => {
  //     if (flyDivScrollableTableRef.current && tblFilterRef.current) {
  //       const w = window.innerWidth;
  //       flyDivScrollableTableRef.current.style.width = `${w - 30}px`;
  //       const h = window.innerHeight - tblFilterRef.current.offsetHeight - 80;
  //       flyDivScrollableTableRef.current.style.height = `${h}px`;
  //     }
  //   };

  //   handleResize();
  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [loadFamilies, rowsPerPage]);


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const selLoginParam = urlParams.get('SelLogin') || '';

    if (selLoginParam) {
      setSelLogin(selLoginParam);

      const tmpLogin = sessionStorage.getItem('TMP_LoginLike') || '';
      const tmpSurname = sessionStorage.getItem('TMP_LNameLike') || '';
      const tmpEmail = sessionStorage.getItem('TMP_EMailLike') || '';

      setLoginFilter(tmpLogin);
      setSurnameFilter(tmpSurname);
      setEmailFilter(tmpEmail);

      // Load saved filters initially
      loadFamilies(
        1,
        rowsPerPage,
        tmpLogin,
        tmpSurname,
        tmpEmail
      );
    } else {
      // Initial load with no search filters
      loadFamilies(1, rowsPerPage, '', '', '');
    }

    const handleResize = () => {
      if (flyDivScrollableTableRef.current && tblFilterRef.current) {
        const w = window.innerWidth;

        flyDivScrollableTableRef.current.style.width = `${w - 30}px`;

        const h =
          window.innerHeight -
          tblFilterRef.current.offsetHeight -
          80;

        flyDivScrollableTableRef.current.style.height = `${h}px`;
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleGoClicked = () => {
    // Store search values in session
    sessionStorage.setItem('TMP_LoginLike', loginFilter);
    sessionStorage.setItem('TMP_LNameLike', surnameFilter);
    sessionStorage.setItem('TMP_EMailLike', emailFilter);

    // Reset selection
    setSelLogin('');
    setSelectedFamily(null);

    // ONLY HERE do the search
    loadFamilies(
      1,
      rowsPerPage,
      loginFilter,
      surnameFilter,
      emailFilter
    );
  };
  // Handle Modify Sales button click
  const handleModifySales = () => {
    if (!selectedFamily) {
      alert('Please select a row.');
      return false;
    }

    if (selectedFamily.SalesLogin !== 'Sales_NewYLA') {
      alert('Family A/c not created using new YLA.\nNo sales record exists.');
      return false;
    }

    setSelLogin(selectedFamily.Login);
    return true;
  };

  // Handle Edit Profile button click
  const handleEditProfile = () => {
    if (!selectedFamily) {
      alert('Please select a row.');
      return false;
    }

    if (selectedFamily.SalesLogin) {
      setHowAdded(selectedFamily.SalesLogin);
    }
    setSelLogin(selectedFamily.Login);
    return true;
  };

  // Handle row selection
  const handleRowSelect = (family: Family) => {
    setSelectedFamily(family);
    setSelLogin(family.Login);
    if (family.SalesLogin) {
      setHowAdded(family.SalesLogin);
    }
  };

  // Handle Edit button click
  const handleEdit = () => {
    if (!selectedFamily) {
      alert('Please select a row.');
      return;
    }

    // Store search values in session
    sessionStorage.setItem('TMP_LoginLike', loginFilter);
    sessionStorage.setItem('TMP_LNameLike', surnameFilter);
    sessionStorage.setItem('TMP_EMailLike', emailFilter);

    // Navigate to edit page
    let url = `/DEALER/EL_DealerRegisterFamily?Login=${selectedFamily.Login}&HowAdded=${howAdded}`;
    navigate(url);
  };

  // Handle Modify Sales button click
  const handleModifySalesClick = () => {
    if (!selectedFamily) {
      alert('Please select a row.');
      return;
    }

    if (selectedFamily.SalesLogin !== 'Sales_NewYLA') {
      alert('Family A/c not created using new YLA.\nNo sales record exists.');
      return;
    }

    // Store search values in session
    sessionStorage.setItem('TMP_LoginLike', loginFilter);
    sessionStorage.setItem('TMP_LNameLike', surnameFilter);
    sessionStorage.setItem('TMP_EMailLike', emailFilter);

    // Navigate to modify sales page
    navigate(`/SALES/SalesModify/EL_SalesModify?SchoolCode=${supportSchoolCode}&FamilyCode=${supportFamilyCode}&Login=${selectedFamily.Login}&BackTo=ListFamilies`);
  };

  // Set table dimensions
  useEffect(() => {
    const timer = setTimeout(() => {
      if (flyDivScrollableTableRef.current && tblFilterRef.current) {
        const w = window.innerWidth;
        flyDivScrollableTableRef.current.style.width = `${w - 30}px`;
        const h = window.innerHeight - tblFilterRef.current.offsetHeight - 80;
        flyDivScrollableTableRef.current.style.height = `${h}px`;
      }
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  // Show error message if present
  useEffect(() => {
    if (errorMesg) {
      alert(errorMesg);
    }
  }, [errorMesg]);

  // Set selection when selLogin changes
  useEffect(() => {
    if (selLogin && families.length > 0) {
      const selected = families.find(f => f.Login === selLogin);
      if (selected) {
        setSelectedFamily(selected);
        // Scroll to the selected row
        const table = document.getElementById('fly_divScrollableTable');
        if (table) {
          const rows = table.getElementsByTagName('tr');
          for (let i = 0; i < rows.length; i++) {
            const cells = rows[i].getElementsByTagName('td');
            if (cells.length > 0 && cells[1].textContent?.trim() === selLogin) {
              rows[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
              break;
            }
          }
        }
      }
    }
  }, [selLogin, families]);

  // Pagination
  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > Math.ceil(totalRecords / rowsPerPage)) return;
    loadFamilies(newPage, rowsPerPage);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <h2 style={{ color: "navy", textAlign: "center", margin: "5px", fontFamily: "Arial", fontSize: "18px" }}>{supportSchoolCode}</h2>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "1%", marginBottom: "5px", marginRight: "5px", marginTop: "0px" }}>
        <a href="/SUPPORT/DealerDashboard" style={{ textDecoration: 'underline', color: 'blue', fontWeight: 'bolder', fontFamily: "Arial", fontSize: "14px" }}>Back To Menu</a>
        <a href="/SUPPORT/SupportLoggedOut" style={{ textDecoration: 'underline', color: 'blue', fontWeight: 'bolder', fontFamily: "Arial", fontSize: "14px" }}>Logout</a>
      </div>
      {/* Filter Table */}
      <table id="tblFilter" width="100%" ref={tblFilterRef}>
        <tbody>
          <tr>
            <td align="left">
              Login:&nbsp;
              <input
                type="text"
                id="txtLogin"
                value={loginFilter}
                onChange={(e) => setLoginFilter(e.target.value)}
                style={{
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  border: 'solid 1px #80A0FF',
                  backgroundColor: 'White'
                }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              SurName:&nbsp;
              <input
                type="text"
                id="txtSurName"
                value={surnameFilter}
                onChange={(e) => setSurnameFilter(e.target.value)}
                style={{
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  border: 'solid 1px #80A0FF',
                  backgroundColor: 'White'
                }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              EMail:&nbsp;
              <input
                type="text"
                id="txtEMail"
                value={emailFilter}
                onChange={(e) => setEmailFilter(e.target.value)}
                style={{
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  border: 'solid 1px #80A0FF',
                  backgroundColor: 'White'
                }}
              />
              &nbsp;&nbsp;
              <button
                id="btnGO"
                onClick={handleGoClicked}
                style={{
                  width: '60px',
                  height: '29px',
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  cursor: 'pointer'
                }}
              >
                GO
              </button>
            </td>
            <td align="right">
              <button
                id="btnModifySales"
                onClick={handleModifySalesClick}
                style={{
                  width: '100px',
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  cursor: 'pointer'
                }}
              >
                Modify Sales
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                id="btnModifySales"
                onClick={handleEdit}
                style={{
                  width: '100px',
                  fontFamily: 'Arial',
                  fontSize: '8pt',
                  cursor: 'pointer',
                  // backgroundColor:"#fff",
                  // color:"black",
                  // border:"1px solid black"
                }}
              >
                Edit Profile
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Family List Table */}
      <div style={{ margin: '5px', backgroundColor: 'white', textAlign: "center" }}>
        <div
          id="fly_divScrollableTable"
          ref={flyDivScrollableTableRef}
          style={{
            overflow: 'auto',
            width: `${window.innerWidth - 30}px`,
            height: `${window.innerHeight - (tblFilterRef.current?.offsetHeight || 0) - 80}px`,
            border: '1px solid #80A0FF'
          }}
        >
          <table width="100%" cellPadding={5} cellSpacing={0} style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#c7ddfd' }}>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>#</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Login</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Password</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>First</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>SurName</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Status</th>
                <th colSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Date</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Child</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Products</th>
                <th colSpan={4} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Maths Doctor</th>
                <th colSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Default Lesson Plan</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Incentives</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>A/cType</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>LessonPlan</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>EarnPoints</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>EMail</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Dongles</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>How Added</th>
                <th rowSpan={2} style={{ padding: '5px', textAlign: 'left', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>VoucherCode</th>
              </tr>
              <tr style={{ backgroundColor: '#c7ddfd' }}>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Registered</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Expiry</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Licenses</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Brick</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>KGap</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>WPlan</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>Mathematics</th>
                <th style={{ padding: '5px', textAlign: 'center', color: '#2859ac', fontSize: '10pt', border: '1px solid #80A0FF', fontWeight: "normal" }}>English</th>
              </tr>
            </thead>
            <tbody>
              {families.map((family, index) => {
                const isSelected = selectedFamily?.Login === family.Login;

                return (
                  <tr
                    key={index}
                    onClick={() => handleRowSelect(family)}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: isSelected
                        ? 'orange'
                        : index % 2 === 0
                          ? '#f4faff'
                          : 'white'
                    }}
                  >
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{index + 1}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.Login}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.Password}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.FName}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.LName}</td>

                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.ActivityStatus}</td>

                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>
                      {family.RegisteredDate ? new Date(family.RegisteredDate).toLocaleDateString() : ''}
                    </td>

                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>
                      {family.ExpiryDate ? new Date(family.ExpiryDate).toLocaleDateString() : ''}
                    </td>

                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}
                      dangerouslySetInnerHTML={{ __html: family.ChildName }} />

                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}
                      dangerouslySetInnerHTML={{ __html: family.Products }} />

                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.MDs}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.Brick}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.KGap}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.WPlan}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.D_LP}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.D_LP_E}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.MyInCentives}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.AccountType}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.CanAccessLessonPlan}</td>
                    <td style={{ padding: '5px', textAlign: 'center', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.CanEarnPoints}</td>

                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.EMail}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.Dongles}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.SalesLogin}</td>
                    <td style={{ padding: '5px', textAlign: 'left', color: '#000', fontSize: '10pt', borderRight: '1px solid #a3c0e8' }}>{family.VoucherCode}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <button
          onClick={() => handlePageChange(1)}
          disabled={startRecNo === 1}
          style={{ marginRight: '5px', cursor: startRecNo === 1 ? 'not-allowed' : 'pointer' }}
        >
          {'<<'}
        </button>
        <button
          onClick={() => handlePageChange(startRecNo - 1)}
          disabled={startRecNo === 1}
          style={{ marginRight: '5px', cursor: startRecNo === 1 ? 'not-allowed' : 'pointer' }}
        >
          {'<'}
        </button>
        <span>
          {startRecNo} of {Math.ceil(totalRecords / rowsPerPage)}
        </span>
        <button
          onClick={() => handlePageChange(startRecNo + 1)}
          disabled={startRecNo >= Math.ceil(totalRecords / rowsPerPage)}
          style={{ marginLeft: '5px', cursor: startRecNo >= Math.ceil(totalRecords / rowsPerPage) ? 'not-allowed' : 'pointer' }}
        >
          {'>'}
        </button>
        <button
          onClick={() => handlePageChange(Math.ceil(totalRecords / rowsPerPage))}
          disabled={startRecNo >= Math.ceil(totalRecords / rowsPerPage)}
          style={{ marginLeft: '5px', cursor: startRecNo >= Math.ceil(totalRecords / rowsPerPage) ? 'not-allowed' : 'pointer' }}
        >
          {'>>'}
        </button>
        &nbsp;&nbsp;
        <select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            loadFamilies(1, Number(e.target.value));
          }}
          style={{ fontFamily: 'Arial', fontSize: '8pt' }}
        >
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
        </select>
        &nbsp;
        <button
          onClick={() => loadFamilies(startRecNo, rowsPerPage)}
          style={{ fontFamily: 'Arial', fontSize: '8pt', cursor: 'pointer' }}
        >
          Refresh
        </button>
      </div>

      {/* Hidden fields */}
      <input type="hidden" id="hidSelLogin" value={selLogin} />
      <input type="hidden" id="hidHowAdded" value={howAdded} />
      <input type="hidden" id="hidPostBack" value="" />
      <input type="hidden" id="hidStartRecNo" value={startRecNo} />
      <input type="hidden" id="hidRowsPerPage" value={rowsPerPage} />
    </div>
  );
};

export default EL_ListFamilies;